import { Component, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ApiConfiguration }from '../../services/http/api-configuration';
import { ApiService }from '../../services/http/api.service';


@Component({
  selector: 'app-data-refresh',
  templateUrl: './data-refresh.component.html',
  styleUrls: ['./data-refresh.component.scss']
})
export class DataRefreshComponent implements OnInit {
  StateList;
  RegionList;
  MonthList = [];
  YearList = [];
  state;
  month;
  year;
  stateCode;
  detail : any;
  multiselect :boolean = true;
  toast: any;
  constructor(
    private apiService : ApiService,
    private apiConfiguration : ApiConfiguration,
  ) { }

  
  ngOnInit() {
    this.MonthList=[
      { id: 1, month :"JAN"},
      { id: 2, month :"FEB"},
      { id: 3, month :"MAR"},
      { id: 4, month :"APR"},
      { id: 5, month :"MAY"},
      { id: 6, month :"JUN"},
      { id: 7, month :"JUL"},
      { id: 8, month :"AUG"},
      { id: 9, month :"SEP"},
      { id: 10, month :"OCT"},
      { id: 11, month :"NOV"},
      { id: 12, month :"DES"},
    ];
    this.YearList=[
      { id: 1, year :"2020"},
      { id: 2, year :"2021"},
      { id: 3, year :"2022"},
    ]
   
    this.getState();
    // this.dropdownSettings = {
    //   singleSelection: false,
    //   idField: 'item_id',
    //   textField: 'item_text',
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   itemsShowLimit: 3,
    //   allowSearchFilter: true
    // };
  }
 
  getState(){
    this.apiService.get(this.apiConfiguration.configGetStates).
    subscribe((res : any)=>{
      this.StateList = res.data;
      console.log(res);
    })
  }
  selectedItem(data ,i){
    if(i == 1){
      data.filter((res)=>{
       this.state= res.state_name
       this.StateList.forEach(element => {
        if (this.state == element.state_name){
          this.stateCode = element.state_code;
        }
      });
       
        
      })
    }else if(i == 2){
      if (data == ""){
        this.month =""
      }else{
        data.filter((res)=>{
          this.month= res.id
           
         })
      }
      
    }
    else{
      data.filter((res)=>{
        this.year= res.year
         
       })
    }
     this.detail =[
      {
      state_code : this.stateCode,
      month :this.month,
      year : this.year
    }
  ]
  }
  SubmitData()
  {
   let payload={
     "target_id": "","batch_name":""
   }
   payload.target_id=this.stateCode;
   payload.batch_name="datarefresh"
   this.apiService
   .post(this.apiConfiguration.targetruninsert, payload)
   .subscribe((res: any) => {
     if (res.status == 201 || res.status == 200) {
       this.toast.Success("Data Refresh Request Added successfully");
       //this.showNextStep();
     }
   });
   //alert(this.targetId);
  }

}
